<template>
  <nav class="nav-inner_nir" :class="{ [curTheme]: true }">
    <div class="nir_menu">
      <router-link
        v-for="(l, i) in linksLoc"
        :key="`nir-link-${i}`"
        class="nir_link"
        :class="{ active: i === activeI }"
        :to="l.url">
        {{ l.text }}
      </router-link>
    </div>
  </nav>
</template>

<script>
export default {

  props: {
    links: Array,
    useUserLinks: false,
  },

  data() {
    return {
      linksLoc: [],
      activeI: -1,
      userCommonLinks: [
        { url: '/user/objects', text: 'Мои объекты', activeRegexp: '/user/objects' },
        { url: '/user/bookmarks', text: 'Избранное', activeRegexp: '/user/bookmarks' },
        { url: '/user/users', text: 'Мои контакты', activeRegexp: '/user/users' },
        { url: '/user/subscriptions', text: 'Мои подписки', activeRegexp: '/user/subscriptions' },
        { url: '/user/recommendations', text: 'Мои рекомендации', activeRegexp: '/user/recommendations' },
        { url: '/user/profile', text: 'Мой профиль', activeRegexp: '/user/profile' },
        { url: '/user/drafts', text: 'Мои черновики', activeRegexp: '/user/drafts' },
        { url: '/user/deals', text: 'Мои сделки', activeRegexp: '/user/deals' },
        { url: '/user/events', text: 'Уведомления', activeRegexp: '/user/events' },
      ],
      userOrgAdminLinks: [
        { url: '/user/organization', text: 'Моя организация', activeRegexp: '/user/organization/.+' },
      ],
    };
  },

  mounted() {
    this.setLinks();
  },

  computed: {
    orgAdminIn() {
      return this.$store.getters['user/getWhereOrgAdmin'];
    },
  },

  watch: {
    orgAdminIn() {
      if (this.useUserLinks) {
        this.setLinks();
      }
    },
  },

  methods: {

    setLinks() {
      if (this.links) {
        this.linksLoc = this.links;
      } else if (this.useUserLinks) {
        this.linksLoc = this.userCommonLinks;
        // Add default orgId to section url
        if (this.orgAdminIn.length) {
          this.userOrgAdminLinks[0].url += `/${this.orgAdminIn[0]}`;
          this.linksLoc = this.linksLoc.concat(this.userOrgAdminLinks);
        }
      }
      this.setActive();
    },

    setActive() {
      const curRoute = this.$route.path;
      for (let i = 0; i < this.linksLoc.length; i += 1) {
        const re = new RegExp(this.linksLoc[i].activeRegexp);
        if (re.test(curRoute)) {
          this.activeI = i;
          break;
        }
      }
    },

    gotoUrl(url) {
      this.$router.push({ path: url });
    },

  },

};
</script>

<style lang="scss">
@import "../styles/common/main";

.nav-inner_nir {
  .nir_menu {
    max-width: 1790px;
    margin: 0 auto;
    line-height: 25px;
    @media (max-width: 600px) {
      margin: -20px 0;
    }
    .nir_link {
      cursor: pointer;
      font-size: 15px;
      text-transform: uppercase;
      margin: 0 17px;
      color: #d3bbe5 !important;
      @include transition;
      white-space: nowrap;
      display: inline-block;
      &.active,
      &:hover {
        color: #fff !important;
      }
      @media (max-width: 600px) {
        font-size: 14px;
        margin: 8px 0;
        display: block;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/NavInner.vue